(function () {
  const SELECTORS = {
    root: '.section--blackbook-wrap',
    reveal: '.blackbook-reveal',
    illustration: '.section--blackbook-illustration',
    illustrationImages: '.blackbook-illustration__imgs',
    illustrationImage: '.blackbook-illustration__img',
    logoBack: '.blackbook-illustration__logo-back',
    video: '.video-product',
    advantages: '.section--blackbook-advantages',
    advantageImageFirst: '.blackbook-advantages__img-1',
    advantageImageSecond: '.blackbook-advantages__img-2',
    infoSection: '.section--info1',
    infoContainer: '.section--info1 .container',
    infoBlock: '.info-block',
    infoImage: '.info-block__img',
    infoTitle: '.info-block__title',
    infoText: '.info-block__text',
    craftItem: '.blackbook-craft__item'
  };

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function mobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function tablet() {
    return window.matchMedia('(max-width: 1024px)').matches;
  }

  function responsiveValue(mobileValue, tabletValue, desktopValue) {
    if (mobile()) {
      return mobileValue;
    }

    if (tablet()) {
      return tabletValue;
    }

    return desktopValue;
  }

  function toArray(items) {
    return Array.prototype.slice.call(items);
  }

  function initReveal(root) {
    toArray(root.querySelectorAll(SELECTORS.reveal)).forEach(function (item) {
      window.gsap.fromTo(item, {
        y: 64,
        autoAlpha: 0
      }, {
        y: 0,
        autoAlpha: 1,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: item,
          start: 'top 88%',
          once: true
        }
      });
    });
  }

  function initIllustration(root) {
    let section = root.querySelector(SELECTORS.illustration);

    if (!section) {
      return;
    }

    let imagesContainer = section.querySelector(SELECTORS.illustrationImages);
    let images = toArray(section.querySelectorAll(SELECTORS.illustrationImage));

    if (imagesContainer && images.length) {
      let scrollDistance = function () {
        return '+=' + (mobile() ? 750 : 1400);
      };
      let offsetMultiplier = function () {
        return 1;// mobile() ? 1.12 : 1.32;
      };
      let centerOffset = function (image, axis) {
        let containerSize = axis === 'x' ? imagesContainer.offsetWidth : imagesContainer.offsetHeight;
        let imageStart = axis === 'x' ? image.offsetLeft : image.offsetTop;
        let imageSize = axis === 'x' ? image.offsetWidth : image.offsetHeight;

        return (containerSize / 2 - (imageStart + imageSize / 2)) * offsetMultiplier();
      };

      window.gsap.fromTo(imagesContainer, {
        scale: 0.9
      }, {
        scale: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top 70%',
          end: scrollDistance,
          scrub: true,
          invalidateOnRefresh: true
        }
      });

      // window.gsap.to(imagesContainer, {
      //   yPercent: mobile() ? 8 : 20,
      //   ease: 'none',
      //   scrollTrigger: {
      //     trigger: section.querySelector('.blackbook__title') || section,
      //     start: 'top bottom',
      //     end: function () {
      //       return '+=' + (mobile() ? 900 : 1800);
      //     },
      //     scrub: true,
      //     invalidateOnRefresh: true
      //   }
      // });

      window.gsap.fromTo(images, {
        x: function (index, image) {
          return centerOffset(image, 'x');
        },
        y: function (index, image) {
          return centerOffset(image, 'y');
        },
        autoAlpha: 1
      }, {
        x: 0,
        y: 0,
        autoAlpha: 1,
        ease: 'none',
        // stagger: mobile() ? 0.02 : 0.035,
        scrollTrigger: {
          trigger: section,
          start: 'top 70%',
          end: scrollDistance,
          scrub: true,
          invalidateOnRefresh: true
        }
      });
    }

    let logoBack = section.querySelector(SELECTORS.logoBack);
    if (logoBack) {
      window.gsap.to(logoBack, {
        scale: 1.08,
        autoAlpha: 0.82,
        duration: 1.8,
        yoyo: true,
        repeat: -1,
        ease: 'sine.inOut'
      });
    }
  }

  function initVideo(root) {
    toArray(root.querySelectorAll(SELECTORS.video)).forEach(function (video) {
      let section = video.closest('.section--video-product');

      if (!section) {
        return;
      }

      window.gsap.set(video, {
        transformOrigin: 'center center'
      });

      window.gsap.fromTo(video, {
        scale: 0.86
      }, {
        scale: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: '+=700',
          scrub: true,
          invalidateOnRefresh: true
        }
      });
    });
  }

  function initAdvantages(root) {
    toArray(root.querySelectorAll(SELECTORS.advantages)).forEach(function (section) {
      let imageFirst = section.querySelector(SELECTORS.advantageImageFirst);
      let imageSecond = section.querySelector(SELECTORS.advantageImageSecond);

      if (!imageFirst || !imageSecond) {
        return;
      }

      let timeline = window.gsap.timeline({
        defaults: {
          ease: 'none'
        },
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true
        }
      });

      timeline.fromTo(imageFirst, {
        x: function () {
          return responsiveValue(-10, -12, -24);
        },
        y: function () {
          return responsiveValue(12, 14, 28);
        }
      }, {
        x: function () {
          return responsiveValue(10, 12, 24);
        },
        y: function () {
          return responsiveValue(-12, -14, -28);
        }
      }, 0);

      timeline.fromTo(imageSecond, {
        x: function () {
          return responsiveValue(10, 14, 28);
        },
        y: function () {
          return responsiveValue(-14, -18, -36);
        }
      }, {
        x: function () {
          return responsiveValue(-10, -14, -28);
        },
        y: function () {
          return responsiveValue(14, 18, 36);
        }
      }, 0);
    });
  }


  function initInfo(root) {
    let section = root.querySelector(SELECTORS.infoSection);
    let container = root.querySelector(SELECTORS.infoContainer);

    if (!section || !container || !window.ScrollTrigger.matchMedia) {
      return;
    }

    let originalMarkup = container.innerHTML;

    window.ScrollTrigger.matchMedia({
      '(min-width: 1025px)': function () {
        container.innerHTML = originalMarkup;

        let blocks = toArray(container.querySelectorAll(SELECTORS.infoBlock));
        let blockImages = blocks.map(function (block) {
          return block.querySelector(SELECTORS.infoImage);
        });
        let images = blockImages.filter(function (image) {
          return Boolean(image);
        });

        if (!blocks.length || !images.length) {
          return function () {
            container.innerHTML = originalMarkup;
          };
        }

        let triggers = [];
        let left = document.createElement('div');
        let right = document.createElement('div');

        left.className = 'info-block__left';
        right.className = 'info-block__right';
        container.appendChild(left);
        container.appendChild(right);

        blocks.forEach(function (block, index) {
          left.appendChild(block);

          if (blockImages[index]) {
            right.appendChild(blockImages[index]);
          }
        });

        function setActive(activeIndex) {
          blockImages.forEach(function (image, index) {
            if (!image) {
              return;
            }

            image.classList.toggle('active', index === activeIndex);
            image.classList.toggle('past', index < activeIndex);
          });
        }

        setActive(0);

        let switchPoint = '58%';
        let switchPointRatio = 0.58;
        let lastTextHoldRatio = 0.25;
        let lastBlock = blocks[blocks.length - 1];

        function getLastTextHold() {
          return lastBlock ? Math.min(lastBlock.offsetHeight, window.innerHeight * lastTextHoldRatio) : 0;
        }

        function updateLeftSpacing() {
          left.style.paddingBottom = getLastTextHold() + 'px';
        }

        updateLeftSpacing();
        window.ScrollTrigger.addEventListener('refreshInit', updateLeftSpacing);

        if (images.length > 1) {
          triggers.push(window.ScrollTrigger.create({
            trigger: left,
            start: 'top top',
            end: function () {
              let blockHeight = blocks[0].offsetHeight;
              let blockCount = blocks.length - 1;
              let duration = blockHeight * blockCount;
              let imageHeight = images[0].offsetHeight;
              let lastTitle = lastBlock ? lastBlock.querySelector(SELECTORS.infoTitle) : null;
              let lastTitlePadding = lastTitle ? parseFloat(window.getComputedStyle(lastTitle).paddingTop) || 0 : 0;
              let lastBlockOffset = lastBlock ? lastBlock.getBoundingClientRect().top - left.getBoundingClientRect().top : 0;
              let lastSwitchOffset = lastBlockOffset + lastTitlePadding - window.innerHeight * switchPointRatio;
              let lastTextHold = getLastTextHold();

              if (imageHeight > blockHeight && blockCount > 0) {
                duration = blockHeight * blockCount - imageHeight / blockCount;
              }

              return '+=' + Math.max(blockHeight, duration, lastSwitchOffset + lastTextHold);
            },
            pin: right,
            pinSpacing: false,
            invalidateOnRefresh: true
          }));
        }

        blocks.forEach(function (block, index) {
          let title = block.querySelector(SELECTORS.infoTitle);
          let text = block.querySelector(SELECTORS.infoText);

          triggers.push(window.ScrollTrigger.create({
            trigger: title || block,
            start: function () {
              let paddingTop = title ? parseFloat(window.getComputedStyle(title).paddingTop) || 0 : 0;

              return title ? 'top+=' + paddingTop + ' ' + switchPoint : 'top ' + switchPoint;
            },
            endTrigger: text || title || block,
            end: 'bottom center',
            invalidateOnRefresh: true,
            onEnter: function () {
              setActive(index);
            },
            onEnterBack: function () {
              setActive(index);
            }
          }));
        });

        return function () {
          window.ScrollTrigger.removeEventListener('refreshInit', updateLeftSpacing);
          triggers.forEach(function (trigger) {
            trigger.kill();
          });
          container.innerHTML = originalMarkup;
        };
      },
      '(max-width: 1024px)': function () {
        container.innerHTML = originalMarkup;
        toArray(container.querySelectorAll(SELECTORS.infoImage)).forEach(function (image) {
          image.classList.remove('active', 'past');
        });
      }
    });
  }

  function initCraft(root) {
    if (!window.ScrollTrigger.matchMedia) {
      return;
    }

    window.ScrollTrigger.matchMedia({
      '(min-width: 1281px)': function () {
        let animations = [];
        let animatedElements = [];

        toArray(root.querySelectorAll(SELECTORS.craftItem)).forEach(function (item) {
          let content = item.querySelector('.craft-item__content');
          let image = item.querySelector('.craft-item__img');

          if (!content || !image) {
            return;
          }

          animatedElements.push(content, image);

          animations.push(window.gsap.fromTo(content, {
            yPercent: 140
          }, {
            yPercent: -50,
            ease: 'none',
            scrollTrigger: {
              trigger: item,
              start: 'top bottom',
              end: '+=2000',
              scrub: true,
              invalidateOnRefresh: true
            }
          }));

          animations.push(window.gsap.fromTo(image, {
            yPercent: 30
          }, {
            yPercent: -15,
            ease: 'none',
            scrollTrigger: {
              trigger: item,
              start: 'top bottom',
              end: '+=2000',
              scrub: true,
              invalidateOnRefresh: true
            }
          }));
        });

        return function () {
          animations.forEach(function (animation) {
            if (animation.scrollTrigger) {
              animation.scrollTrigger.kill();
            }

            animation.kill();
          });
          window.gsap.set(animatedElements, {
            clearProps: 'transform'
          });
        };
      },
      '(max-width: 1280px)': function () {
        window.gsap.set(root.querySelectorAll(SELECTORS.craftItem + ' .craft-item__content, ' + SELECTORS.craftItem + ' .craft-item__img'), {
          clearProps: 'transform'
        });
      }
    });
  }

  function refreshAfterLayout(root) {
    let refreshFrame = null;

    function refresh() {
      if (refreshFrame !== null) {
        return;
      }

      refreshFrame = requestAnimationFrame(function () {
        refreshFrame = null;
        window.ScrollTrigger.refresh(true);
      });
    }

    let resizeObserver = new ResizeObserver(refresh);
    resizeObserver.observe(root);

    let ancestor = root;
    while (ancestor && ancestor !== document.body) {
      let previous = ancestor.previousElementSibling;
      while (previous) {
        resizeObserver.observe(previous);
        previous = previous.previousElementSibling;
      }
      ancestor = ancestor.parentElement;
    }

    root.addEventListener('load', refresh, true);
    root.addEventListener('error', refresh, true);
    window.addEventListener('load', refresh, { once: true });

    let sectionWrapper = root.closest('.shopify-section');
    function onSectionUnload(event) {
      if (event.target !== sectionWrapper) {
        return;
      }

      resizeObserver.disconnect();
      cancelAnimationFrame(refreshFrame);
      root.removeEventListener('load', refresh, true);
      root.removeEventListener('error', refresh, true);
      window.removeEventListener('load', refresh);
      document.removeEventListener('shopify:section:unload', onSectionUnload);
    }
    document.addEventListener('shopify:section:unload', onSectionUnload);
  }

  ready(function () {
    let root = document.querySelector(SELECTORS.root);

    if (!root || !window.gsap || !window.ScrollTrigger) {
      return;
    }

    window.gsap.registerPlugin(window.ScrollTrigger);
    window.ScrollTrigger.config({ ignoreMobileResize: true });
    initReveal(root);
    initIllustration(root);
    initVideo(root);
    initAdvantages(root);
    initInfo(root);
    initCraft(root);
    refreshAfterLayout(root);
  });
})();
